var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L11.2814 9.16013L19.5022 0.93934C20.088 0.353553 21.0378 0.353553 21.6236 0.93934C22.2093 1.52513 22.2093 2.47487 21.6236 3.06066L13.4028 11.2814L21.6236 19.5022C22.2093 20.088 22.2093 21.0378 21.6236 21.6236C21.0378 22.2093 20.088 22.2093 19.5022 21.6236L11.2814 13.4028L3.06066 21.6236C2.47487 22.2093 1.52513 22.2093 0.93934 21.6236C0.353553 21.0378 0.353553 20.088 0.93934 19.5022L9.16013 11.2814L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z","fill":"black"}));
}

CrossInline.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
